<template>
  <footer class="app-footer m-0">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="logo-header">
            &copy; RCH S.p.A. {{ moment().format('YYYY') }} - P.IVA 01033470251
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'app-footer'
}
</script>
